import React from "react";
import Navbar from "../GeneralComponents/Navbar";
import SideNav from "../GeneralComponents/SideNav";
import { ReactComponent as Bubbles } from "./Group 11024.svg";
import { useNavigate } from "react-router-dom";

function ContactSuccess() {
  const navigate = useNavigate();

  return (
    <div className="grid grid-cols-1 lg:grid-cols-4">
      <SideNav />
      <div className="col-span-1 lg:col-span-3">
        <Navbar />
        <div className="bg-[#F3F5F9] flex flex-col items-center md:mt-4 lg:mt-4 border h-screen lg:h-[500px] rounded-3xl lg:pb-16 lg:w-[400px] lg:mx-auto lg:scale-[80%]">
          <Bubbles className="pt-12" />
          <button
            onClick={() => {
              navigate("/");
            }}
            className="py-[17px] px-[60px] bg-pw-blue text-white rounded-3xl hover:bg-cyan-500"
          >
            Retry
          </button>
        </div>
      </div>
    </div>
  );
}

export default ContactSuccess;
